import React from 'react';
import { Clock, Calendar, User, Apple } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { AnimatedSection } from '../components/AnimatedSection';
import { gymInfo } from '../mock';

export const Schedule = () => {
  return (
    <div className="min-h-screen bg-black pt-24 pb-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <AnimatedSection animation="fade-zoom" className="text-center mb-16">
          <span className="px-4 py-2 bg-gradient-to-r from-blue-600/20 to-sky-500/20 border border-sky-500/30 rounded-full text-sky-400 text-sm font-semibold backdrop-blur-sm inline-block mb-6">
            HORARIOS
          </span>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            <span className="bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
              Horarios de
            </span>
            <br />
            <span className="bg-gradient-to-r from-blue-400 to-sky-400 bg-clip-text text-transparent">
              Atención
            </span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Estamos disponibles para ti con horarios amplios
          </p>
        </AnimatedSection>

        {/* Horarios Card */}
        <AnimatedSection animation="elastic-scale" delay={0.2}>
        <div className="max-w-4xl mx-auto mb-16">
          <Card className="bg-gradient-to-br from-gray-900 to-black border-sky-500/20 hover:scale-105 transition-all duration-500 animate-glow-pulse">
            <CardContent className="p-12">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                <div>
                  <div className="bg-gradient-to-br from-blue-600 to-sky-500 p-4 rounded-xl w-fit mx-auto mb-4">
                    <Calendar className="h-8 w-8 text-white" />
                  </div>
                  <p className="text-sky-400 font-semibold mb-2 text-lg">Lunes - Viernes</p>
                  <p className="text-white text-2xl font-bold">6:00 - 23:00</p>
                </div>
                <div>
                  <div className="bg-gradient-to-br from-blue-600 to-sky-500 p-4 rounded-xl w-fit mx-auto mb-4">
                    <Clock className="h-8 w-8 text-white" />
                  </div>
                  <p className="text-sky-400 font-semibold mb-2 text-lg">Sábado</p>
                  <p className="text-white text-2xl font-bold">8:00 - 21:00</p>
                </div>
                <div>
                  <div className="bg-gradient-to-br from-blue-600 to-sky-500 p-4 rounded-xl w-fit mx-auto mb-4">
                    <Clock className="h-8 w-8 text-white" />
                  </div>
                  <p className="text-sky-400 font-semibold mb-2 text-lg">Domingo</p>
                  <p className="text-white text-2xl font-bold">9:00 - 20:00</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        </AnimatedSection>

        {/* Services Info */}
        <AnimatedSection animation="slide-up-bounce" delay={0.4}>
        <div className="mt-16 max-w-4xl mx-auto">
          <Card className="bg-gradient-to-br from-gray-900 to-black border-sky-500/20 hover:scale-105 transition-transform duration-500">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">Nuestros Servicios</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-300">
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <User className="h-5 w-5 text-sky-400" />
                    <h4 className="font-semibold text-sky-400">Entrenamiento Personalizado</h4>
                  </div>
                  <p className="text-sm pl-8">
                    Contamos con entrenadores personales certificados que diseñan rutinas adaptadas a tus objetivos específicos.
                  </p>
                </div>
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <Apple className="h-5 w-5 text-sky-400" />
                    <h4 className="font-semibold text-sky-400">Nutrióloga Especializada</h4>
                  </div>
                  <p className="text-sm pl-8">
                    Nuestra nutrióloga deportiva te ayudará a crear un plan alimenticio personalizado para maximizar tus resultados.
                  </p>
                </div>
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <Clock className="h-5 w-5 text-sky-400" />
                    <h4 className="font-semibold text-sky-400">Horarios Flexibles</h4>
                  </div>
                  <p className="text-sm pl-8">
                    Abierto casi todo el día para que puedas entrenar cuando mejor te convenga.
                  </p>
                </div>
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <Calendar className="h-5 w-5 text-sky-400" />
                    <h4 className="font-semibold text-sky-400">Reserva tu Sesión</h4>
                  </div>
                  <p className="text-sm pl-8">
                    Agenda tu sesión de entrenamiento personalizado o consulta nutricional con anticipación.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        </AnimatedSection>
      </div>
    </div>
  );
};
